import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	isGlobalSaveActivated: false,
	apisCalled: {
		isAttachmentAPICalled: false,
		isNotesAPICalled: false,
		isRecruitAPICalled: false,
	},
};

const globalSaveReducerSlice = createSlice({
	name: 'globalSaveReducer',
	initialState,
	reducers: {
		setGlobalSave(state, action) {
			const updateChange = {
				isGlobalSaveActivated: action.payload.isGlobalSaveActivated,
				apisCalled: { ...action.payload.apisCalled },
			};
			return {
				...updateChange,
			};
		},
	},
});

export const { setGlobalSave } = globalSaveReducerSlice.actions;
export default globalSaveReducerSlice.reducer;
